import React from 'react';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/app-paths';

import { INSIGHTS_FULL_DRAWER_ID } from '../../utils/const';
import { InsightsDrawer } from './InsightsDrawer';

export const InsightsFullDrawerRender = () => {
  const { params } = useQueryParams();

  const entityTagFromParams = params[queryKeys.entityTag];
  const activeDrawer = params[queryKeys.activeDrawer];

  if (entityTagFromParams && activeDrawer === INSIGHTS_FULL_DRAWER_ID) {
    return (
      <ErrorBoundaryWrapper showBorder={false}>
        <InsightsDrawer
          key={entityTagFromParams}
          entityTag={entityTagFromParams}
        />
      </ErrorBoundaryWrapper>
    );
  }

  return null;
};
